import React, { useEffect,useState,useRef } from "react";
import axios from 'axios';
import swal from "sweetalert";
import { Link } from 'react-router-dom';

import Header from '../components/Header';
import HubungiKami from '../components/HubungiKami';

function FaqWellground(){

  const [data, setData] = useState([])
  const [category, setCategory] = useState([])
  const renderAfterCalled = useRef(false)

  useEffect(() => {
    if (!renderAfterCalled.current) {
      getData()
      getCategory()
    }
    renderAfterCalled.current = true;
  }, [])

  const getData = async () => {
    await axios.get(`${process.env.REACT_APP_API_WGN}cms/api/wgn/v1/web/faq`, {
    })
    .then(response => {
      console.log('FAQ',JSON.stringify(response.data.data))
      setData(response.data.data)
    })
    .catch(error => {
      swal("Maaf","Terjadi Kesalahan, mohon refresh ulang.", "warning");
    })
  }

  const getCategory = async () => {
    await axios.get(`${process.env.REACT_APP_API_WGN}cms/api/wgn/v1/web/category-faq`, {
    })
    .then(response => {
      console.log('KATEGORI',JSON.stringify(response.data.data))
      setCategory(response.data.data)
    })
    .catch(error => {
      swal("Maaf","Terjadi Kesalahan, mohon refresh ulang.", "warning");
    })
  }
  return (
    <>
      {<Header/>}
      <section className="page-cover pt-5 mb-5" style={{ background: '#0E5442' }}>
        <h1 className="page-title" style={{ color: '#fff' }}>
            FAQ
        </h1>
      </section>
      <div className="containerfluid mb-5">
        <div className="col-md-8 offset-md-2" style={{marginTop:'-10%'}}>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <nav>
                                <div className="nav nav-tabs-2 tab-home nav-justified" id="nav-tab" role="tablist">
                                  <button className="nav-link active" id="nav-semua-tab" data-bs-toggle="tab" data-bs-target="#nav-semua" type="button" role="tab" aria-controls="nav-semua" aria-selected="false" style={{ color: '#0E5442' }}>
                                    Semua
                                  </button>
                                  {
                                    category.map((value, index) =>(
                                      <button className="nav-link" id={`nav-${value.name.toLowerCase()}-tab`} data-bs-toggle="tab" data-bs-target={`#nav-${value.name.toLowerCase()}`} type="button" role="tab" aria-controls={`nav-${value.name.toLowerCase()}`}aria-selected="false" style={{ color: '#0E5442' }}>
                                        {value.name}
                                      </button>
                                    ))
                                  }
                                </div>
                            </nav>
                            <div className="tab-content mt-4" id="nav-tabContent">
                                <div className="tab-pane fade show active" id="nav-semua" role="tabpanel" aria-labelledby="nav-semua-tab">
                                    <div className="accordion semuaExample">
                                      {
                                        data.map((value, index) =>(
                                          <div className="accordion-item">
                                            <h2 className="accordion-header" id={`semua${index}`}>
                                              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapsesemua${index}`} aria-expanded="false" aria-controls={`collapsesemua${index}`} style={{ color: '#0E5442' }}>
                                                {value.question}
                                              </button>
                                            </h2>
                                            <div id={`collapsesemua${index}`} className="accordion-collapse collapse" aria-labelledby={`semua${index}`} data-bs-parent="#semuaExample">
                                              <div className="accordion-body">{value.answer}</div>
                                            </div>
                                          </div>
                                        ))
                                      }
                                    </div>
                                </div>
                                {
                                  category.map((value, index) => (
                                    <div
                                      key={index}
                                      className="tab-pane fade"
                                      id={`nav-${value.name.toLowerCase()}`}
                                      role="tabpanel"
                                      aria-labelledby={`nav-${value.name.toLowerCase()}-tab`}
                                    >
                                      <div className="accordion" id={`${value.name.toLowerCase()}Example`}>
                                        {
                                          Array.isArray(value.faq) && value.faq.length > 0 ? (
                                            value.faq.map((values, indexs) => (
                                              <div className="accordion-item" key={indexs}>
                                                <h2
                                                  className="accordion-header"
                                                  id={`${value.name.toLowerCase()}${indexs}`}
                                                >
                                                  <button
                                                    className="accordion-button collapsed"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse${value.name.toLowerCase()}${indexs}`}
                                                    aria-expanded="false"
                                                    aria-controls={`collapse${value.name.toLowerCase()}${indexs}`}
                                                    style={{ color: '#0E5442' }}
                                                  >
                                                    {values.question}
                                                  </button>
                                                </h2>
                                                <div
                                                  id={`collapse${value.name.toLowerCase()}${indexs}`}
                                                  className="accordion-collapse collapse"
                                                  aria-labelledby={`${value.name.toLowerCase()}${indexs}`}
                                                  data-bs-parent={`#${value.name.toLowerCase()}Example`}
                                                >
                                                  <div className="accordion-body">{values.answer}</div>
                                                </div>
                                              </div>
                                            ))
                                          ) : (
                                            <div className="accordion-item">
                                              <div className="accordion-body">Tidak ada data FAQ</div>
                                            </div>
                                          )
                                        }
                                      </div>
                                    </div>
                                  ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <HubungiKami />
    </>
  );
}
  
export default FaqWellground;